<template lang="pug">
    Authenticate(defaultTab="register" :registration="false")
        .contentpage
            validation-observer(v-slot="{ invalid }" ref="form")
                form(@submit.prevent="submit")
                    .section(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
                        Heading(
                            v-if="section.key === 'heading'"
                            :section="section"
                            :edit="true"
                            heading-field-name="Überschrift"
                            heading-rules="required"
                            sub-heading-field-name="Thema"
                            sub-heading-rules="required"
                            @change="updateSectionContent"
                        )
                        .container(v-if="section.key === 'heading'")
                            .column.is-offset-1.is-one-fifth.is-10
                                .field
                                    select-with-validation.select-field(
                                        rules="required"
                                        name="Diskussionsthemen"
                                        v-model="tags"
                                        :options="tagOptions"
                                        :multiple="true"
                                        :searchable="true"
                                        :taggable="true"
                                        :allow-empty="false"
                                        :show-labels="true"
                                        track-by="name"
                                        label="name"
                                        placeholder="Diskussionsthemen festlegen..."
                                        deselect-label="mit Enter abwählen"
                                        selected-label="ausgewählt"
                                        select-label="mit Enter auswählen"
                                        tag-placeholder="mit Enter ein neues Diskussionsthema erstellen"
                                        @tag="addTag"
                                    )
                        Description(
                            v-if="section.key === 'description'"
                            :section="section"
                            :edit="true"
                            name="Beitrag"
                            rules="required"
                            @change="updateSectionContent"
                        )
                    .section
                        .container
                            .column.is-offset-1.is-10
                                button.button.is-primary(
                                    :disabled="invalid || saving"
                                    :class="{ 'is-loading': saving }"
                                ) Speichern
</template>

<script>

import Vue from 'vue'

import _ from 'lodash'
import uniqid from 'uniqid'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

// import Multiselect from 'vue-multiselect'

import router from '@/router'
import Authenticate from '@/components/Authenticate'
import Heading from '@/components/Heading'
import Description from '@/components/Description'
import SelectWithValidation from '@/components/Partials/SelectWithValidation'

export default {
    name: 'BlogPageForm',
    data() {
        return {
            tags: [],
            tagOptions: [],
            loadingTagOptions: false,
            saving: false,
            sections: [
                {
                    id: uniqid('new:'),
                    key: 'heading',
                    name: 'Überschrift',
                    position: 1,
                    contents: [{
                        id: uniqid('new:'),
                        key: 'heading',
                        title: '',
                        sub_title: '',
                        labels: {
                            title: 'Überschrift',
                            sub_title: 'Thema',
                        }
                    }],
                }, {
                    id: uniqid('new:'),
                    key: 'description',
                    name: 'Beschreibung',
                    position: 3,
                    contents: [{
                        id: uniqid('new:'),
                        key: 'content',
                        text: '',
                        labels: {
                            text: 'Beitrag'
                        }
                    }],
                },
            ],
        }
    },
    components: {
        Authenticate,
        Heading,
        Description,
        // Multiselect,
        ValidationObserver,
        ValidationProvider,
        SelectWithValidation,
    },
    computed: {
        ...mapGetters({
            recaptchaSiteKey: 'googleRecaptchaSiteKey',
            cms: 'CMS',
        })
    },
    methods: {
        updateSectionContent(sID, cID, field, value) {
            let section, content

            section = this.sections.find(section => section.id === sID)
            if (section && section.contents) {
                content = section.contents.find(content => content.id === cID)
            }

            if (content && field) {
                content[field] = value
                // Vue.set(this.sections.heading.contents[0], field, value)
            }
        },
        addTag(name) {
            const tag = { name }
            this.tagOptions.push(tag)
            this.tags.push(tag)
        },
        redirect() {
            const route = '/netzwerk'
            router.push(route)
        },
        async submit() {
            this.saving = true

            const valid = await this.$refs.form.validate()
            if (valid && this.recaptchaSiteKey) {
                await this.$recaptchaLoaded()
                try {
                    const token = await this.$recaptcha('auth')

                    let title
                    let sections = [{
                        id: uniqid('new:'),
                        area: "teaser",
                        key: 'category-page-teaser',
                        name: 'Anreißer',
                        position: -1,
                        contents: [{
                            id: uniqid('new:'),
                            key: 'teaser',
                            text: '',
                        }],
                    }]
                    this.sections.forEach(el => {
                        if (el.key === 'heading') title = el.contents[0].title
                        let section = {
                            id: el.id,
                            key: el.key,
                            name: el.name,
                            position: el.position,
                            contents: [],
                        }
                        _.get(el, 'contents', []).forEach(co => {
                            let content = {
                                id: co.id,
                                key: co.key,
                                name: co.name,
                                position: co.position,
                                title: co.title,
                                sub_title: co.sub_title,
                                text: co.text,
                                hyperlink: co.hyperlink,
                                images: co.images,
                            }
                            section.contents.push(content)
                        })
                        sections.push(section)
                    })
                    let page = {
                        key: '', // generate slug server side
                        title,
                        view: 'BlogPage',
                        category: {
                            key: 'blog-posts',
                        },
                        sections,
                        tags: this.tags
                    }

                    this.create(page)
                        .then(() => {
                            this.addMessage({
                                id: _.uniqueId(),
                                title: 'Erfolg',
                                text: 'Der Beitrag wurde erfolgreich gespeichert.',
                                type: 'success',
                                autoclose: 5000
                            });
                            this.redirect()
                        })
                        .catch(() => {
                            this.addMessage({
                                id: _.uniqueId(),
                                title: 'Fehler',
                                text: 'Der Beitrag konnte nicht gespeichert werden.',
                                type: 'danger',
                                autoclose: 5000
                            });
                        })
                        .finally(() => {
                            this.saving = false
                        })

                } catch (error) {
                    this.addMessage({
                        id: _.uniqueId(),
                        title: 'Es gibt ein technisches Problem.',
                        text: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                        type: 'danger',
                        autoclose: 5000
                    });
                    this.saving = false
                }
            } else {
                // TODO
                // submit without recaptcha ?

                this.addMessage({
                    id: _.uniqueId(),
                    title: 'Es gibt ein technisches Problem.',
                    text: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    type: 'danger',
                    autoclose: 5000
                });
                this.saving = false
            }
        },
        ...mapMutations({
            addMessage: 'addMessage',
        }),
        ...mapActions('currentPage', {
            fetchTagOptions: 'fetchTagOptions',
            create: 'create'
        }),
    },
    mounted() {
        this.loadingTagOptions = true
        this.fetchTagOptions({ cms: parseInt(this.cms.id), categoryKeys: ['blog-posts'] }).then(tags => {
            this.tagOptions = _.removeDeepByKey(tags.filter(tag => tag.numberOfPublishedPages > 0), '__typename')
        }).finally(() => {
            this.loadingTagOptions = false
        })
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, { siteKey: this.recaptchaSiteKey })
        }
    }
}
</script>

<style lang="sass" scoped>
    .section /deep/ .ql-editor
        min-height: 240px
</style>
